import Home from '@/Home'
import Provider from '@/Provider'
import VueRouter from 'vue-router'

// The viewer is "/" and shows the signed-in user's own ride: the WebSocket server takes the
// user from the token, never from the URL. Old /<userId> links (shared from older app builds)
// land on "/" too.
const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  // Test provider emulator, local dev only
  ...(process.env.APP_ENV === 'production' ? [] : [{
    path: '/provider/:userId',
    name: 'provider',
    component: Provider
  }]),
  {
    path: '/:userId',
    redirect: '/'
  }
]
const router = new VueRouter({
  routes,
  mode: 'history'
})

export default router
